import React from 'react'
import Paper from '@material-ui/core/Paper'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ForumIcon from '@material-ui/icons/Forum'

const useStyles = makeStyles({
  root: {
    marginBottom: 30,
    borderRadius: 4,
    textAlign: 'center',
    textTransform: 'uppercase',
    marginTop: 30,
    paddingTop: 80,
    paddingBottom: 80
  },
  wrapperIcon: {
    background: '#bcbccb',
    width: 200,
    height: 200,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    margin: '0 auto'
  },
  title: {
      color: '#bcbccb',
      textTransform: 'none',
  },
  subtitle: {
      fontWeight: 200,
      color:  '#bcbccb',
      textTransform: 'none',
      marginBottom: 50
  }
})

const EmptyPlaceholder = ({ loading, ...rest }) => {
  const classes = useStyles()
  return (
    <Paper component={'article'} className={classes.root} elevation={2}>
      <Typography className={classes.title} variant={'h5'}>Ainda não há tópicos nesta categoria.</Typography>
      <Typography className={classes.subtitle} variant={'h5'}>Que tal iniciar um novo tópico?</Typography>
      <div className={classes.wrapperIcon}>
        <ForumIcon style={{ fontSize: 150 }} />
      </div>
    </Paper>
  )
}
export default EmptyPlaceholder
